{
  "units.title": "Units",
  "units.description": "Every listing your brokerage can sell, with live prices and availability.",
  "units.search": "Search code, project, developer…",
  "units.loadFailed": "Units couldn't load. Check your connection and refresh the page.",
  "units.col.unit": "Unit",
  "units.col.project": "Project",
  "units.col.developer": "Developer",
  "units.col.phase": "Phase",
  "units.col.type": "Type",
  "units.col.beds": "Beds",
  "units.col.baths": "Baths",
  "units.col.bua": "BUA",
  "units.col.size": "Size",
  "units.col.price": "Total price",
  "units.col.dp": "Down payment",
  "units.col.remaining": "Remaining",
  "units.col.finishing": "Finishing",
  "units.col.status": "Status",
  "units.col.actions": "Actions",
  "units.status.available": "Available",
  "units.status.reserved": "Reserved",
  "units.status.sold": "Sold",
  "units.tag.add": "Add tag",
  "units.tag.none": "Remove tag",
  "units.price.onRequest": "Price on request",
  "units.card.dp": "{share}% down payment",
  "units.spec.beds": "{count, plural, one {# bed} other {# beds}}",
  "units.spec.baths": "{count, plural, one {# bath} other {# baths}}",
  "units.spec.area": "{area} m²",
  "units.filter.developer": "Developer",
  "units.filter.project": "Project",
  "units.filter.phase": "Phase",
  "units.filter.type": "Type",
  "units.filter.beds": "Beds",
  "units.filter.bedsOption": "{beds} beds",
  "units.filter.status": "Status",
  "units.filter.tag": "Tag",
  "units.filter.price": "Price",
  "units.filter.apply": "Apply range",
  "units.view.label": "Layout",
  "units.view.grid": "Cards",
  "units.view.table": "Table",
  "units.stats.showing": "Showing",
  "units.stats.available": "Available",
  "units.stats.average": "Average price",
  "units.stats.value": "Available value",
  "units.empty.title": "No units yet",
  "units.empty.body": "Add your first listing, or import your inventory sheet in one go.",
  "units.empty.filteredTitle": "No units match",
  "units.empty.filteredBody": "Try fewer filters or a wider price range.",
  "units.action.open": "Open unit",
  "units.action.claims": "Claims",
  "units.action.offer": "Generate offer",
  "units.offer.preparing": "Preparing the offer…",
  "units.offer.downloaded": "Offer downloaded: {name}",
  "units.offer.failed": "The offer couldn't be generated. Try again.",
  "units.delete.title": "Delete unit {code}?",
  "units.delete.body": "It disappears from listings, offers and searches. This can't be undone from the app.",
  "units.delete.done": "Unit deleted.",
  "units.import.action": "Import",
  "units.import.title": "Import units",
  "units.import.body": "Upload an Excel or CSV sheet. Developers and projects must already exist, matched by name.",
  "units.import.pick": "Choose a file",
  "units.import.formats": ".xlsx or .csv",
  "units.import.template": "Download a template",
  "units.import.running": "Importing…",
  "units.import.done": "Units imported.",
  "units.import.failed": "The import failed. Check the sheet against the template and try again.",
  "units.form.editTitle": "Edit unit",
  "units.form.photos": "Photos",
  "units.form.photosReplace": "Uploading new photos replaces all current ones.",
  "units.form.location": "Location",
  "units.form.specs": "Specifications",
  "units.form.price": "Price & details",
  "units.form.code": "Unit code",
  "units.form.number": "Unit number",
  "units.form.land": "Land area",
  "units.form.features": "Features",
  "units.form.additional": "Additional details",
  "units.form.notes": "Internal notes",
  "units.form.notesHint": "Only your team sees these. They never appear on offers.",
  "units.form.pickDeveloper": "Choose a developer",
  "units.form.pickProject": "Choose a project",
  "units.form.pickDeveloperFirst": "Choose a developer first",
  "units.form.useRemaining": "Use EGP {amount} (total − down payment)",
  "units.form.saving": "Saving…",
  "units.form.created": "Unit added.",
  "units.form.saved": "Changes saved.",
  "units.form.error.photos": "Add at least one photo.",
  "units.form.error.developer": "Choose a developer.",
  "units.form.error.project": "Choose a project.",
  "units.form.error.code": "Enter the unit code.",
  "units.form.error.type": "Enter the unit type.",
  "units.form.error.beds": "Enter the bedrooms.",
  "units.form.error.baths": "Enter the bathrooms.",
  "units.form.error.bua": "Enter the built-up area.",
  "units.form.error.size": "Enter the unit size.",
  "units.form.error.price": "Enter the total price.",
  "units.form.error.dp": "Enter the down payment.",
  "units.form.error.remaining": "Enter the remaining amount.",
  "units.form.error.number": "Enter a number.",
  "units.form.error.priceSplit": "Down payment plus remaining can't be more than the total price.",
  "units.form.error.areaSplit": "Built-up plus land area can't be more than the unit size.",
  "dropzone.title": "Drop photos here, or click to choose",
  "dropzone.hint": "JPG, PNG or WebP. Large photos are resized for you.",
  "dropzone.cover": "Cover",
  "dropzone.remove": "Remove photo",
  "units.tab.overview": "Overview",
  "units.tab.notes": "Team notes",
  "units.tab.activity": "Activity",
  "units.detail.back": "All units",
  "units.detail.photos": "Unit photos",
  "units.detail.allPhotos": "{count, plural, one {View photo} other {View all # photos}}",
  "units.detail.perMetre": "Price per m²",
  "units.detail.derived": "BUA",
  "units.detail.previewOffer": "Preview the offer",
  "units.detail.listedBy": "Listed by",
  "units.detail.claimedBy": "Last approved claim: {name}",
  "units.detail.internal": "Internal",
  "units.detail.notFound": "This unit is gone",
  "units.detail.notFoundBody": "It may have been deleted, or the link is wrong.",
  "units.notes.add": "Add note",
  "units.notes.placeholder": "Write a note for your team… (Ctrl+Enter to send)",
  "units.notes.emptyTitle": "No notes yet",
  "units.notes.emptyBody": "Notes stay inside your team. Use them for owner details, viewings or negotiation history.",
  "units.activity.emptyTitle": "No history yet",
  "units.activity.emptyBody": "Every change to this unit will show here.",
  "units.activity.system": "System",
  "units.activity.event.created": "listed this unit",
  "units.activity.event.updated": "updated the unit",
  "units.activity.event.deleted": "deleted the unit",
  "claims.status.pending": "Pending",
  "claims.status.approved": "Approved",
  "claims.status.rejected": "Rejected",
  "claims.approve": "Approve",
  "claims.reject": "Reject",
  "claims.approved": "Claim approved.",
  "claims.rejected": "Claim rejected.",
  "claims.comment": "Why is this listing yours?",
  "claims.empty.title": "No claims",
  "units.detail.noPhotos": "No photos yet",
  "units.detail.addPhotos": "Add photos",
  "claims.description": "Agents claim the listings they brought in. Approve the ones that check out.",
  "claims.col.agent": "Requested by",
  "claims.col.when": "When",
  "claims.empty.pending": "Nothing waiting for review",
  "claims.empty.approved": "No approved claims yet",
  "claims.empty.rejected": "No rejected claims",
  "claims.empty.body": "New claims appear here as agents send them from a unit page."
}
